<template>
  <nav @click="closeNav">
    <ul>
      <li><router-link :to="{name: 'assignments'}">Assignments</router-link></li>
      <li><router-link :to="{name: 'binder'}">Binder</router-link></li>
      <!-- TODO: Add channels after MVP -->
      <!-- <li>
        <expander>
          <a slot="header" href="" @click.prevent="$_.noop" @keypress.prevent="$_.noop">Channels</a>
          <ul class="nav__inner">
            <li v-for="channel in channels" :key="channel.id">
              <router-link :to="{name: 'channelDetail', params: { id: channel.id }}">{{ channel.name }}</router-link>
            </li>
          </ul>
        </expander>
      </li> -->
      <!-- <li><router-link :to="{name: 'profile'}">Profile</router-link></li> -->
      <li><router-link :to="{name: 'logout'}">{{$session.session.isMimic ? 'Close' : 'Logout'}}</router-link></li>
    </ul>
  </nav>
</template>

<script>
  import store from "@/store"

  export default {
    name: 'SecondaryNavigation',
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        channels: []
      }
    },
    created () {
      // TODO: Add channels after MVP
      // store.findAll('channels').then((channels) => {
      //   this.channels = channels
      // })
    },
    mounted () {
      $(window).on("keyup.secNav", (e) => {
        if(e.which == 27) {
          this.closeNav()
        }
      })
    },
    destroyed () {
      $(window).off(".secNav")
    },
    methods: {
      closeNav () {
        this.$emit('close')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  nav {
    @include transition();
    @include position(absolute, 0 0 null null);
    @include size(320px 100vh);
    box-shadow: 0 0 2em 0 rgba(0,0,0,.25);
    &.v-enter,
    &.v-leave-to {
      opacity:0;
    }
    &::before {
      @include position(absolute, 0 0 0 0);
      background:$color-white; content:'';
    }
  }

  ul {
    @include list-style-reset;
    @include transition()
    position:absolute; top:0; bottom:$header-height; right:$gutter; display:flex; flex-direction:column; align-items:center; justify-content:center;
    @include media(medium) {
      align-items:flex-end;
    }
    .v-enter &,
    .v-leave-to & {
      transform:translateX(100%); opacity:0;
    }
    .v-enter-to & {
      transition-delay:150ms;
    }
    a {
      @include transition();
      @include font-size(xlarge, $headline:true)
      display:block; padding:4rem 0; color:$color-gray-darkest; text-transform:uppercase; text-decoration:none; outline:none;
      &:hover, &:focus {
        color:$color-primary;
      }
      &.router-link-active {
        color:$color-primary;
        &:hover, &:focus {
          color:$color-primary-lighter;
        }
      }
    }
    &.nav__inner {
      margin-top:1rem; font-weight:300;
      a {
        padding:0.5rem 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppHeader/SecondaryNavigation.vue